var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-flex uk-flex-column flat-panel"},[_c('div',{staticClass:"uk-flex uk-flex-row flat-menu"},[_c('div',{staticClass:"uk-flex uk-flex-row flat-fiber"},[_c('router-link',{staticClass:"router-link-tarif-menu",attrs:{"to":"/internet/flat-panel/fiber"}},[_vm._v("Оптичне підключення")])],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }